export default __webpack_public_path__ + "static/media/chair.912760ad.jpg";